import React from 'react';
import { IconX, IconFilter } from '@tabler/icons-react';
interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCategory: string;
  selectedChild: string;
  onCategoryChange: (category: string) => void;
  onChildChange: (child: string) => void;
  onClearFilters: () => void;
}
const categories = ['Tutte', 'Scuola', 'Burocrazia', 'Salute', 'Sport'];
const children = ['Tutti', 'Sofia', 'Marco'];
export function FilterModal({
  isOpen,
  onClose,
  selectedCategory,
  selectedChild,
  onCategoryChange,
  onChildChange,
  onClearFilters
}: FilterModalProps) {
  if (!isOpen) return null;
  const hasActiveFilters = selectedCategory !== 'Tutte' || selectedChild !== 'Tutti';
  const handleClearAndClose = () => {
    onClearFilters();
    onClose();
  };
  return <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-yeppy-text bg-opacity-20 z-40 transition-opacity duration-300" onClick={onClose} data-id="element-146" />

      {/* Modal */}
      <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl z-50 transform transition-transform duration-300 ease-out" style={{
      animation: isOpen ? 'slideUp 0.3s ease-out' : 'slideDown 0.3s ease-out'
    }} data-id="element-147">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-yeppy-text border-opacity-10" data-id="element-148">
          <div className="flex items-center gap-2" data-id="element-149">
            <IconFilter className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-150" />
            <h2 className="font-rubik font-semibold text-lg text-yeppy-text" data-id="element-151">
              Filtra
            </h2>
          </div>
          <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-full bg-yeppy-bg text-yeppy-text transition-colors" data-id="element-152">
            <IconX className="w-5 h-5" stroke={1.5} data-id="element-153" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 space-y-6 max-h-[60vh] overflow-y-auto" data-id="element-154">
          {/* Category filter */}
          <div data-id="element-155">
            <label className="font-poppins text-sm font-medium text-yeppy-text mb-3 block" data-id="element-156">
              Categoria
            </label>
            <div className="flex flex-wrap gap-2" data-id="element-157">
              {categories.map(category => <button key={category} onClick={() => onCategoryChange(category)} className={`px-4 py-2 rounded-full font-poppins text-sm font-medium transition-all ${selectedCategory === category ? 'bg-yeppy-text text-white' : 'bg-yeppy-bg text-yeppy-text'}`} data-id="element-158">
                  {category}
                </button>)}
            </div>
          </div>

          {/* Child filter */}
          <div data-id="element-159">
            <label className="font-poppins text-sm font-medium text-yeppy-text mb-3 block" data-id="element-160">
              Bambino
            </label>
            <div className="flex flex-wrap gap-2" data-id="element-161">
              {children.map(child => <button key={child} onClick={() => onChildChange(child)} className={`px-4 py-2 rounded-full font-poppins text-sm font-medium transition-all ${selectedChild === child ? 'bg-yeppy-text text-white' : 'bg-yeppy-bg text-yeppy-text'}`} data-id="element-162">
                  {child}
                </button>)}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-4 border-t border-yeppy-text border-opacity-10 flex gap-3" data-id="element-163">
          {hasActiveFilters && <button onClick={handleClearAndClose} className="flex-1 px-4 py-3 rounded-2xl font-poppins text-sm font-semibold text-yeppy-text bg-yeppy-bg transition-colors" data-id="element-164">
              Cancella filtri
            </button>}
          <button onClick={onClose} className="flex-1 px-4 py-3 rounded-2xl font-poppins text-sm font-semibold transition-colors" style={{
          backgroundColor: '#1D2A36',
          color: '#FFFFFB'
        }} data-id="element-165">
            Applica
          </button>
        </div>
      </div>

      <style jsx data-id="element-166">{`
        @keyframes slideUp {
          from {
            transform: translateY(100%);
          }
          to {
            transform: translateY(0);
          }
        }
        @keyframes slideDown {
          from {
            transform: translateY(0);
          }
          to {
            transform: translateY(100%);
          }
        }
      `}</style>
    </>;
}